import AuthStore from "./auth";
import LadderStore from "./ladder";

const Store = {
	_authStore: AuthStore,
	_ladderStore: LadderStore
};

export default Store;